// src/components/common/utils/DueAmount.js
import React, { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { Badge } from 'react-bootstrap';
import { db } from '../../../firebase';
import { useAuth } from '../../../context/AuthContext';
import { invoiceOutstanding, round2, fmt } from '../../common/utils/outstanding';

const DueAmount = ({ bookingID }) => {
  const { user } = useAuth();
  const { bid } = user.claims || {};

  const [outstanding, setOutstanding] = useState(0);

  useEffect(() => {
    if (!bid || !bookingID) {
      setOutstanding(0);
      return;
    }

    const fetchOutstanding = async () => {
      try {
        const ref = collection(
          db,
          'Businesses',
          bid,
          'Bookings',
          bookingID,
          'Invoices'
        );
        const snapshot = await getDocs(ref);

        let totalOutstanding = 0;
        console.log(bid);

        snapshot.forEach((docSnap) => {
          const inv = docSnap.data() || {};
          const invID = docSnap.id || "";
          console.log(invID);

          totalOutstanding += invoiceOutstanding(inv);
        });

        setOutstanding(round2(totalOutstanding));
      } catch (err) {
        console.error('DueAmount fetch error:', err);
        setOutstanding(0);
      }
    };

    fetchOutstanding();
  }, [bid, bookingID]);

  const due = round2(outstanding);

  if (due === 0) {
    return (
      <Badge
        bg="success"
        className="px-3 py-1 mb-0 fw-600 fw-normal"
      >
        Paid
      </Badge>
    );
  }

  return `₹ ${fmt(due)}`;
};

export default DueAmount;